<script>
  import {External, M} from "../external";

  export let data,
    onClick,
    useStaticImage = false,
    tooltipOptions = null,
    showDisabledBadge = false,
    isSystem = false;

  let generateImage = function (box) {
    if (useStaticImage) {
      if (box.staticImage) {
        return box.staticImage;
      } else {
        return External.resources + "/images/marketing/templates/" + box.name + ".jpg?v=" + External.resourcesVersion;
      }
    }

    if (box.modified) {
      return External.getThumbnailsFromBase("s/" + data.dir + "/", "emails") + box.name + ".png?v=" + box.modified.epochSecond;
    }

    if(isSystem) {
      return External.resources + "/images/emails/system-emails/" + box.name + ".png?v=" + External.resourcesVersion;
    }

    return External.resources + "/images/emails/email-placeholder.PNG?v=" + External.resourcesVersion;
  };

  let onMoreClick = function (event, template) {
    if (tooltipOptions == null) {
      return;
    }

    let options = typeof tooltipOptions === "function" ? tooltipOptions(template) : tooltipOptions;
    if (!options.length) {
      return;
    }
    External.Tools.showTooltipOptions(External.$(event.target), options, function (target, idx, text, tag) {
      onClick(template.name, tag);
    });
  };
</script>

<div>
  {#if data.templates && data.templates.length > 0}
    {#each data.templates as template (template)}
      <div class="system-email-box cursor-pointer">
        {#if tooltipOptions != null}
          <a class="email-more-options" on:click={(event) => onMoreClick(event, template)} ><span class="material-icons">more_vert </span></a>
        {/if}
        <div class="wrapper relative f-left" on:click={() => onClick(template.name)}>
          <img class="system-email-box-img" src={generateImage(template)} />
          {#if isSystem || template.subject}
            <h4 class="system-email-box-title">{isSystem ? (M['SYSTEM_EMAIL_NAME_' + template.name.toUpperCase()] || template.subject) : template.subject}</h4>
          {/if}
          {#if showDisabledBadge && !template.enabled}
			<div class="email-template-disabled flex flex-row align-center justify-center">
			  <span>{M.ACCOUNT_STATUS_DISABLED}</span>
			</div>
          {/if}
        </div>
      </div>
    {/each}
  {/if}
</div>

<style>
  .more-options {
    background: url(/images/sprite.png?v=416) no-repeat center -511px;
    width: 19px;
    height: 52px;
    margin-left: 3px;
    opacity: 0.7;
    transition: opacity 0.3s ease;
    float: right;
    display: none;
  }

  .system-email-box:hover .more-options {
    display: block;
  }

  .email-template-disabled {
	position: absolute;
	width: 100%;
	height: calc(100% - 34px);
	background: rgba(255, 255, 255, 0.7);
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
  }

  .email-template-disabled span {
	font-size: 14px;
	color: #fff;
	background: #222;
	padding: 8px 20px;
	display: inline-block;
	margin: 0 auto;
	border-radius: 4px;
  }
</style>
